
import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
@Component
export default class TreeSelect extends Vue {
  // 自定义按钮 项
  @Prop({
    type: Array,
    default: () => [],
  })
  options: Array<any>

  // 默认标签宽度
  @Prop({
    type: Number,
    default: 240,
  })
  selectWidth: number

  // 默认选中值
  @Prop({
    type: String,
    default: '',
  })
  value: string

  @Prop({
    type: Boolean,
    default: false,
  })
  disabled: boolean

  render(h) {
    let self = this
    return h(
      'i-select',
      {
        props: {
          value: this.value,
          disabled: this.disabled,
          filterable: true
        },
        style: {
          width: this.selectWidth + 'px',
        },
        on: {
          input: (value) => {
            self.$emit('input', value || this.value)
          },
        },
        ref: 'select',
      },
      [this.renderOptions(h)]
    )
  }
  renderOptions(h, arr?: any[], op?: any[], isChild?: boolean) {
    op = op || []
    arr = arr || this.options
    let style: any = {
      'padding-left': '16px',
    }
    if (isChild) {
      let cssText = ''
      let lastOp = op[op.length - 1]
      let pdLeft: any = ''
      if (lastOp && lastOp.data.style['padding-left']) {
        pdLeft = lastOp.data.style['padding-left']
        pdLeft = parseInt(pdLeft) * 1.5 + 'px'
      }
      style['padding-left'] = pdLeft
    } else {
      style['padding-left'] = '16px'
    }
    arr.forEach((item) => {
      op = op.concat(this.getOptionList(h, item, style))
      if (item.children) {
        op = this.renderOptions(h, item.children, op, true)
      }
    })
    return op
  }
  getOptionList(h, item, style) {
    let self = this
    let disabled = false
    let obj = {
      value: item.value,
      level: item.level,
      code: item.code,
    }
    return h(
      'i-option',
      {
        props: {
          value: JSON.stringify(obj),
          disabled: disabled,
        },
        style: style,
      },
      item.label
    )
  }
}
